import { routes as auth } from './auth'
import { routes as notFound } from './notFound'
import { routes as home } from './home'
import { routes as products } from './products'
import { routes as orders } from './orders'
import { routes as bot } from './bot'

export default [
  ...auth,
  ...notFound,
  ...home,
  ...products,
  ...orders,
  ...bot
]
